import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import './style.less';

const Specifications = ({ product_id, style, surfaces }) => {
  return (
    <div className="specifications">
      <ul>
        <li>
          <div className="specTitle bold">
            {t`Product number`}
            {': '}
          </div>
          <div className="specText text">{product_id}</div>
        </li>
        {style && (
          <li>
            <div className="specTitle bold">
              {t`Style`}
              {': '}
            </div>
            <div className="specText text">{style}</div>
          </li>
        )}
        {surfaces.length > 0 &&
          <li>
            <span className="specTitle bold">
              {t`Surface`}
              {': '}
            </span>
            <span className="specText text">
              {surfaces.map((surface, i) => {
                const last = surfaces.length - 1;
                return `${surface}${i !== last ? ' / ' : ''}`;
              })}
            </span>
          </li>
        }
      </ul>
    </div>
  );
};

const mapStateToProps = ({ app }) => {
  return {
    product_id: app.data.product_id,
    style: app.data.style,
    surfaces: app.data.surfaces,
  };
};

export default connect(mapStateToProps)(Specifications);
